import { render, staticRenderFns } from "./EmployeesPoints.vue?vue&type=template&id=22c01c62&"
import script from "./EmployeesPoints.vue?vue&type=script&lang=js&"
export * from "./EmployeesPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports